(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
  (() => {
    // Survives theme-editor section re-renders so a popup the merchant closed
    // doesn't auto-open again after every settings change.
    let popupDismissedInEditor = false;

    const initializePopupSchedules = () => {
      document.querySelectorAll('promo-popup[data-display-mode]').forEach((popup) => {
        if (popup.dataset.scheduleInitialized === 'true') return;

        const modal = popup.querySelector('.sign-up-popup-modal');
        const overlay = popup.querySelector('.sign-up-popup-overlay');
        if (!modal || !overlay || popup.dataset.displayMode === 'success_testing') return;

        popup.dataset.scheduleInitialized = 'true';
        const storageKey = `promo-popup-dismissed-v2-${window.location.host}`;
        const subscribedKey = `promo-bar-subscribed-${window.location.host}`;
        const delayMilliseconds = Math.max(0, Number(popup.dataset.delaySeconds) || 0) * 1000;
        const frequencyMilliseconds = Math.max(0, Number(popup.dataset.delayDays) || 0) * 86400000;
        const isTestMode = popup.dataset.displayMode === 'testing';
        const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
        const bypassFrequency = isTestMode || isThemeEditor;
        const isSubscriptionResponse = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

        const readStorage = (key) => {
          try {
            return window.localStorage.getItem(key);
          } catch (error) {
            return null;
          }
        };

        const writeDismissedTime = () => {
          try {
            window.localStorage.setItem(storageKey, String(Date.now()));
          } catch (error) {
            return;
          }
        };

        const dismissedAt = Number(readStorage(storageKey)) || 0;
        const isInsideFrequencyWindow = dismissedAt > 0 && Date.now() - dismissedAt < frequencyMilliseconds;
        const isSubscribed = () => Boolean(readStorage(subscribedKey));

        const startCountdown = () => {
          if (popup.dataset.displayTimer !== 'true') return;

          const minutesElement = modal.querySelector('.popup-modal__timer__minutes');
          const secondsElement = modal.querySelector('.popup-modal__timer__seconds');
          if (!minutesElement || !secondsElement) return;

          let remaining = Math.max(0, Math.round((Number(popup.dataset.timerDuration) || 0) * 60));
          const render = () => {
            minutesElement.textContent = Math.floor(remaining / 60);
            secondsElement.textContent = String(remaining % 60).padStart(2, '0');
          };

          render();
          const intervalId = window.setInterval(() => {
            remaining -= 1;
            if (remaining < 0 || !popup.isConnected) {
              window.clearInterval(intervalId);
              return;
            }
            render();
          }, 1000);
        };

        popup.querySelectorAll('.promp-popup__close-btn').forEach((closeButton) => {
          closeButton.addEventListener('click', () => {
            if (isThemeEditor) popupDismissedInEditor = true;
            if (!bypassFrequency) writeDismissedTime();
            modal.classList.remove('popup-modal--active');
            overlay.classList.remove('popup-overlay--active');
          });
        });

        if (
          (isThemeEditor && popupDismissedInEditor)
          || isSubscriptionResponse
          || (!bypassFrequency && isInsideFrequencyWindow)
          || (!bypassFrequency && isSubscribed())
        ) return;

        window.setTimeout(() => {
          if (!popup.isConnected || (!bypassFrequency && isSubscribed())) return;
          modal.classList.add('popup-modal--active');
          overlay.classList.add('popup-overlay--active');
          startCountdown();
        }, delayMilliseconds);
      });
    };

    const initializeWheels = () => {
      document.querySelectorAll('promo-popup[data-popup-style="wheel"]').forEach((popup) => {
        if (popup.dataset.wheelInitialized === 'true') return;

        const form = popup.querySelector('.newsletter-form');
        const wheel = popup.querySelector('.promo-wheel__image');
        const wheelMotion = popup.querySelector('[data-wheel-motion]');
        const status = popup.querySelector('[data-wheel-status]');
        const submitButton = form && form.querySelector('[type="submit"]');
        if (!form || !wheel || !submitButton) return;

        popup.dataset.wheelInitialized = 'true';

        const submitFormNatively = () => {
          form.dataset.readyToSubmit = 'true';
          submitButton.disabled = false;
          form.requestSubmit(submitButton);
        };

        const writeSubscribedFlag = () => {
          try {
            window.localStorage.setItem(`promo-bar-subscribed-${window.location.host}`, JSON.stringify({ subscribed: true }));
          } catch (error) {
            return;
          }
        };

        const showSuccessPopup = () => {
          const successModal = document.querySelector('.success-popup-modal');
          const successOverlay = document.querySelector('.success-popup-overlay');
          if (!successModal || !successOverlay) {
            submitFormNatively();
            return;
          }

          writeSubscribedFlag();

          const launcher = popup.nextElementSibling;
          if (launcher && launcher.matches('[data-wheel-launcher]')) launcher.hidden = true;

          const signupModal = popup.querySelector('.sign-up-popup-modal');
          const signupOverlay = popup.querySelector('.sign-up-popup-overlay');
          if (signupModal) signupModal.classList.remove('popup-modal--active');
          if (signupOverlay) signupOverlay.classList.remove('popup-overlay--active');
          successOverlay.classList.add('popup-overlay--active');
          successModal.classList.add('popup-modal--active');

          const closeSuccessPopup = () => {
            successModal.classList.remove('popup-modal--active');
            successOverlay.classList.remove('popup-overlay--active');
          };
          successOverlay.addEventListener('click', closeSuccessPopup);
          const successCloseButton = successModal.querySelector('.popup-modal__close');
          if (successCloseButton) successCloseButton.addEventListener('click', closeSuccessPopup);
          const successDismissButton = successModal.querySelector('.popup-modal__dismiss-btn');
          if (successDismissButton) successDismissButton.addEventListener('click', closeSuccessPopup);
        };

        submitButton.addEventListener('click', (event) => {
          if (form.dataset.readyToSubmit === 'true') return;

          event.preventDefault();
          if (form.dataset.spinning === 'true') return;
          if (!form.reportValidity()) return;

          form.dataset.spinning = 'true';
          submitButton.disabled = true;
          if (status) status.textContent = popup.dataset.spinningLabel;
          if (wheelMotion) wheelMotion.classList.add('is-spinning');
          // 6 full turns + 240° lands on the "5% OFF" segment.
          // 5% OFF sits 120° clockwise from 12 o'clock on the wheel artwork;
          // rotating 240° moves that segment to 12 o'clock where the pointer is.
          const rotation = 2400;
          wheel.style.transform = `rotate(${rotation}deg)`;

          const finishDelay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 200 : 4200;
          window.setTimeout(() => {
            form.dataset.readyToSubmit = 'true';
            submitButton.disabled = false;
            fetch(form.action, { method: 'POST', body: new FormData(form) })
              .then((response) => {
                const params = new URL(response.url).searchParams;
                const posted = params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';
                if (response.ok && posted) {
                  showSuccessPopup();
                } else {
                  // Rejected, or a bot challenge intercepted the request — the standard
                  // full-page submit lets Shopify render the challenge page or errors.
                  form.requestSubmit(submitButton);
                }
              })
              .catch(() => form.requestSubmit(submitButton));
          }, finishDelay);
        });
      });
    };

    const initializeWheelLaunchers = () => {
      document.querySelectorAll('[data-wheel-launcher]').forEach((launcher) => {
        if (launcher.dataset.initialized === 'true') return;

        const popup = launcher.previousElementSibling;
        const modal = popup && popup.querySelector('.sign-up-popup-modal');
        const overlay = popup && popup.querySelector('.sign-up-popup-overlay');
        const openButton = launcher.querySelector('[data-wheel-launcher-open]');
        const closeButton = launcher.querySelector('[data-wheel-launcher-close]');
        if (!popup || !modal || !overlay || !openButton || !closeButton) return;

        launcher.dataset.initialized = 'true';
        launcher.addEventListener('dragstart', (event) => event.preventDefault());
        const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
        if (isThemeEditor && popupDismissedInEditor) launcher.hidden = false;
        const subscribedKey = `promo-bar-subscribed-${window.location.host}`;
        const isSubscribed = () => {
          try {
            return Boolean(window.localStorage.getItem(subscribedKey));
          } catch (error) {
            return false;
          }
        };

        let dragState = null;
        let suppressNextClick = false;

        const edgeGap = 8;

        const positionAtCenter = (centerX, centerY) => {
          const launcherRect = launcher.getBoundingClientRect();
          const minimumX = launcherRect.width / 2 + edgeGap;
          const maximumX = window.innerWidth - launcherRect.width / 2 - edgeGap;
          const minimumY = launcherRect.height / 2 + edgeGap;
          const maximumY = window.innerHeight - launcherRect.height / 2 - edgeGap;
          launcher.style.left = `${Math.min(maximumX, Math.max(minimumX, centerX))}px`;
          launcher.style.top = `${Math.min(maximumY, Math.max(minimumY, centerY))}px`;
        };

        const snapToNearestEdge = () => {
          const launcherRect = launcher.getBoundingClientRect();
          const centerX = launcherRect.left + launcherRect.width / 2;
          const centerY = launcherRect.top + launcherRect.height / 2;
          const snappedX = centerX < window.innerWidth / 2
            ? launcherRect.width / 2 + edgeGap
            : window.innerWidth - launcherRect.width / 2 - edgeGap;
          launcher.classList.add('is-settling');
          positionAtCenter(snappedX, centerY);
          window.setTimeout(() => launcher.classList.remove('is-settling'), 300);
        };

        popup.querySelectorAll('.promp-popup__close-btn').forEach((button) => {
          button.addEventListener('click', () => {
            if (isThemeEditor || !isSubscribed()) launcher.hidden = false;
          });
        });

        openButton.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;

          const launcherRect = launcher.getBoundingClientRect();
          const centerX = launcherRect.left + launcherRect.width / 2;
          const centerY = launcherRect.top + launcherRect.height / 2;
          launcher.classList.remove('is-settling');
          launcher.style.right = 'auto';
          launcher.style.transform = 'translate(-50%, -50%)';
          launcher.style.left = `${centerX}px`;
          launcher.style.top = `${centerY}px`;
          dragState = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            startCenterX: centerX,
            startCenterY: centerY,
            moved: false,
          };
          openButton.setPointerCapture(event.pointerId);
        });

        openButton.addEventListener('pointermove', (event) => {
          if (!dragState || event.pointerId !== dragState.pointerId) return;

          const deltaX = event.clientX - dragState.startX;
          const deltaY = event.clientY - dragState.startY;
          if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
            dragState.moved = true;
            launcher.classList.add('is-dragging');
          }
          if (dragState.moved) positionAtCenter(dragState.startCenterX + deltaX, dragState.startCenterY + deltaY);
        });

        const finishDragging = (event) => {
          if (!dragState || event.pointerId !== dragState.pointerId) return;
          suppressNextClick = dragState.moved && event.type === 'pointerup';
          if (dragState.moved) snapToNearestEdge();
          dragState = null;
          launcher.classList.remove('is-dragging');
        };

        openButton.addEventListener('pointerup', finishDragging);
        openButton.addEventListener('pointercancel', finishDragging);

        window.addEventListener('resize', () => {
          if (!launcher.isConnected || !launcher.style.left) return;
          const launcherRect = launcher.getBoundingClientRect();
          positionAtCenter(launcherRect.left + launcherRect.width / 2, launcherRect.top + launcherRect.height / 2);
        });

        openButton.addEventListener('click', (event) => {
          if (suppressNextClick) {
            event.preventDefault();
            suppressNextClick = false;
            return;
          }
          if (!isThemeEditor && isSubscribed()) return;
          launcher.hidden = true;
          modal.classList.add('popup-modal--active');
          overlay.classList.add('popup-overlay--active');
        });

        closeButton.addEventListener('click', () => {
          launcher.hidden = true;
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializePopupSchedules();
        initializeWheels();
        initializeWheelLaunchers();
      });
    } else {
      initializePopupSchedules();
      initializeWheels();
      initializeWheelLaunchers();
    }

    document.addEventListener('shopify:section:load', () => {
      initializePopupSchedules();
      initializeWheels();
      initializeWheelLaunchers();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
